import React, { useState } from "react";
import "./ReenableUserConfirmModal.css";

const ReenableUserConfirmModal = ({ user, onConfirm, onCancel, isLoading }) => {
  const [emailInput, setEmailInput] = useState("");
  const [error, setError] = useState("");

  const emailMatches = emailInput === user.email;

  const handleConfirm = () => {
    if (!emailMatches) {
      setError("Email does not match");
      return;
    }
    onConfirm();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && emailMatches) {
      handleConfirm();
    } else if (e.key === "Escape") {
      onCancel();
    }
  };

  return (
    <div className="reenable-user-overlay" onClick={onCancel}>
      <div className="reenable-user-modal" onClick={(e) => e.stopPropagation()}>
        <div className="reenable-user-header">
          <h3>Re-enable User Account</h3>
        </div>

        <div className="reenable-user-body">
          <p>You are about to re-enable access for:</p>
          <div className="reenable-user-info">
            <strong>
              {user.firstName} {user.lastName}
            </strong>
            <span className="reenable-user-email">({user.email})</span>
          </div>

          <div className="reenable-warning">
            ⚠️ Re-enabling will restore system access but NOT organization
            authorizations
          </div>

          <div className="reenable-confirmation">
            <label htmlFor="email-confirm">
              Type the email <strong>{user.email}</strong> as shown to confirm:
            </label>
            <input
              id="email-confirm"
              type="text"
              className="reenable-email-input"
              placeholder={user.email}
              value={emailInput}
              onChange={(e) => {
                setEmailInput(e.target.value);
                setError("");
              }}
              onKeyDown={handleKeyPress}
              autoFocus
              disabled={isLoading}
            />
          </div>

          {error && <div className="reenable-error">{error}</div>}
        </div>

        <div className="reenable-user-footer">
          <button
            className="reenable-cancel-btn"
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="reenable-confirm-btn"
            onClick={handleConfirm}
            disabled={!emailMatches || isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner"></span>
                Re-enabling...
              </>
            ) : (
              "Re-enable User"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReenableUserConfirmModal;
